import { render, staticRenderFns } from "./1Column.vue?vue&type=template&id=39eef0c4"
import script from "./1Column.vue?vue&type=script&lang=js"
export * from "./1Column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports